import { styled } from '@mui/material';

export const Container = styled('div')({
  p: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
});
